import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import styles from "./RiskAnalysis.module.scss";
import { useSelector } from "react-redux";
import GraphAccordion from "../../components/GraphAccordion/GraphAccordion";
import useFetchOrganizationData from "../../actions/useFetchOrganizationData";
import { useTranslation } from "react-i18next";
import Input from "../../components/Input/Input";
import { ReactComponent as SearchIcon } from "../../icons/search.svg";
import classNames from "classnames";
import { BarChart3 } from "lucide-react";

const RiskAnalysis = () => {
  const { t } = useTranslation();

  // Fetch organization data when navigating through URL
  useFetchOrganizationData();

  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("chapter");

  const { findingsData, improvementsData, auditsTasksData } = useSelector(
    (state) => state.organization,
  );
  const meModeActive = useSelector((state) => state.filters.meModeActive);
  const currentUser = useSelector((state) => state.user.email);

  return (
    <MainLayout floatingBarCollapsedByDefault={true}>
      <div className={styles.column}>
        <div className={styles.graphsWrapper}>
          <div className={styles.pageHeader}>
            <h1 className={styles.pageTitle}>
              <BarChart3 className={styles.pageTitleIcon} aria-hidden="true" />
              <span>{t("riskAnalysis.title")}</span>
            </h1>
            <p className={styles.pageSubtitle}>{t("riskAnalysis.subtitle")}</p>
          </div>

          <div className={styles.filtersContainer}>
            <Input
              wrapperClassName={styles.searchInputWrapper}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t("graphAccordion.searchPlaceholder")}
              icon={SearchIcon}
              isClearable={true}
              onClear={() => setSearchQuery("")}
              aria-label={t("graphAccordion.searchPlaceholder")}
            />
            <div className={styles.sortControls}>
              <span className={styles.sortLabel}>{t("riskAnalysis.sortBy")}</span>
              <div className={styles.sortButtons}>
                <button
                  type="button"
                  className={classNames(
                    styles.sortButton,
                    sortBy === "priority" && styles.sortButtonActive,
                  )}
                  onClick={() => setSortBy("priority")}
                >
                  {t("riskAnalysis.sort.priority")}
                </button>
                <button
                  type="button"
                  className={classNames(
                    styles.sortButton,
                    sortBy === "exposure" && styles.sortButtonActive,
                  )}
                  onClick={() => setSortBy("exposure")}
                >
                  {t("riskAnalysis.sort.exposure")}
                </button>
                <button
                  type="button"
                  className={classNames(
                    styles.sortButton,
                    sortBy === "chapter" && styles.sortButtonActive,
                  )}
                  onClick={() => setSortBy("chapter")}
                >
                  {t("riskAnalysis.sort.chapter")}
                </button>
              </div>
            </div>
          </div>
          <GraphAccordion
            auditsTasksData={auditsTasksData}
            findingsData={findingsData}
            improvementsData={improvementsData}
            meModeActive={meModeActive}
            currentUser={currentUser}
            searchQuery={searchQuery}
            sortBy={sortBy}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default RiskAnalysis;
